module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "imagech"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "e9781534435742/images/common.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("THIS WASN’T THE FIRST TIME")]), _vm._v(" I’d been in Principal Pickford’s office. I wasn’t a troublemaker, not in the traditional sense. But I didn’t back down from the truth, and that sometimes landed me in this uncomfortable, stiff-backed chair staring at the framed photographs Pickford kept on his walls. Most of them looked like Florida, and one was my favorite—a single palm tree on a beach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Riley,” he said, pulling my attention away from the beach and toward him. He wasn’t mad. I knew his angry face. And there was a rumor that his shiny dome of a "), _c('span', {
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }, [_vm._v("head glowed red when he got really upset, though I’d never seen that for myself. Today he just looked… tired. “You’re a good student.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He clasped his hands on the top of his dark wood desk. “I don’t like bringing you in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t like being in here, sir.” I added quickly, “No offense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He considered me for a moment through his circular wire-rimmed glasses. “Do you know how busy I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I assumed this was a rhetorical question, so I stayed silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He continued. “Very busy. This is a twenty-four-hours-a-day job. I get phone calls and e-mails around the clock. I am responsible for every teacher, staff member, and student in this building. Sometimes I lie awake at night thinking about the problems I’m going to have to face the next day. So, do you know who my favorite students are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Assuming this was another rhetorical question, I kept my mouth shut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The ones I never have to see,” he answered. “The ones who don’t make me get frustrated e-mails or angry phone calls. The ones who don’t cause trouble for me—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_vm._v("“Sir,” I interrupted. “Why am I here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He jiggled the mouse on his mouse pad, and the screen saver on his monitor dissolved. Behind it was today’s edition of the "), _c('i', [_vm._v("Hawking Observer")]), _vm._v(", with my story at the top. It had posted!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This story went up thirty minutes ago,” Principal Pickford said. “And I’ve already gotten two phone calls. "), _c('i', [_vm._v("Two.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From people thankful that the cafeteria is going to be more careful now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He let out a groan. “No. They were not… "), _c('i', [_vm._v("thankful")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I straightened my shoulders. “Well, they should be. Because of that investigative report, the cafeteria will be extra careful from now on when their supplier changes ingredients.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because of that article,” he said, “people are going to panic and think that their children aren’t safe here. This is all blown out of proportion. The cafeteria made a simple oversight—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An oversight that caused Cee to miss half a day of school,” I cut in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighed heavily. “If Cee felt that something was improperly labeled, she should have gone through the appropriate channels, not to an eighth-grade school-newspaper reporter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("I crossed my arms. “The bottom line is this. Cee had been eating those gluten-free nuggets for two years. But then they changed brands, didn’t check carefully, and didn’t remove the words ‘gluten-free’ from the menu. Now, because of my article, they’ll check "), _c('i', [_vm._v("everything")]), _vm._v(" carefully when there’s a change. And not just for gluten, but for allergens like peanuts. You wouldn’t want a careless supplier to cause a child to go into anaphylactic shock, would you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He snorted. “Of course not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slid out my reporter’s notebook from my bag like I was going to take a quote. “You’re not telling me I should have covered up their mistake, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I’m not saying that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what are you saying, Mr. Pickford?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pinched the bridge of his nose. “You’re dismissed, Riley.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood up quickly, shoving my notebook back into my bag. “Okay, Mr. Pickford. Thanks!” I tried not to let him see my giant smile of satisfaction on the way out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time I got to my lunch table, Ava had nearly finished her salad. I pulled the sandwich out of my brown paper bag and took a huge bite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was that about?” Ava asked as she reached "), _c('span', {
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("up to tighten her blond ponytail. She wore her hair in a ponytail all the time, even when she wasn’t practicing. “I heard your name on the intercom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I chewed for a moment. “My latest investigative report didn’t go over too well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes widened. “Are you in trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was at first, kind of, but not anymore.” I tore off another bite and chewed it quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you get out of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I used words.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded. “You’re good with those.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My dad had this theory that everyone was born with something special. He called it a superskill—like a superpower, but instead of being able to fly, you could just cook really well or whatever. Ava was an amazing gymnast. My friend Cee had a head for business. My grandmother could take the most pathetic, half-dead plant and bring it back to life, every time. So far, my little brother’s only gift seemed to be an unlimited supply of gas. But my dad said that sometimes it took years for someone to find their superskill. I was lucky: I found mine early on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I used them to change people’s minds, to change people’s moods. They were just a selection of letters "), _c('span', {
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("put together in different ways, but words were so powerful. They could change the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, long story short, I was thinking that I could fit you in today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, I hadn’t been listening to Ava’s words. “Um, today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded with a big smile. “Yeah, right after school for like an hour. We could hang out at my house. I could show you the video of my competition last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ahhh, she wanted to hang out. “I can’t today. I have a club after school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have ice cream,” she offered, knowing my love for ice cream had no bounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I had to say no. Not even my beloved ice cream could pull me away from the Red Club. “I really can’t. I have a meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ava’s smile fell. “So skip it. This is the only hour that I have free this week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared down at my sandwich, the jelly oozing over the side of the crust. I felt bad that Ava was so busy all the time. And I was the only one she really hung out with outside school. But I couldn’t just drop my plans when she finally had an hour free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t,” I said. “This is an important meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak",
      "title": "19"
    }
  }, [_vm._v("She rolled her eyes. “Fine. I’ll just go with you, then. At least we’ll be hanging out together. What is the meeting for? The newspaper?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I chewed on my lower lip. “Um, no. You know what I have on Wednesdays.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ava’s face reddened. “Oh. The club I’ll never get to join.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not true,” I protested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ava had been frustrated lately that she hadn’t gotten her period yet. She claimed that she was the “last eighth grader on earth” without it, but obviously that wasn’t true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached across the table and grabbed her hand. “Remember what your mom said. "), _c('i', [_vm._v("Everyone has their own timetable.")]), _vm._v(" And because you’re so active, and your mom got hers later, you’ll probably get yours later too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes glistened. “I just feel like such a weirdo. Everyone else is going through this thing together, and I’m the outsider. You’ve had yours for years!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t had it "), _c('i', [_vm._v("that")]), _vm._v(" long,” I said. “And believe me, it’s not that great. Once you get it, you’ll wish you hadn’t been in such a hurry. We’re talking cramps, zits, bloating, mood swings. Sometimes I look in the toilet and it’s like I sacrificed a goat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak",
      "title": "20"
    }
  }, [_vm._v("She burst out laughing. “Stop! Oh my gosh, stop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feel better?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded. “Except now my cheeks hurt from laughing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt a swell of pride. I’d taken a friend from hurting to laughing. I’d done that with my own words. And after school the Red Club would make Julia feel better too.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d4c3958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781534435742/xhtml/ch03.vue
// module id = 69
// module chunks = 0